export default function FeaturedLoader({ title, subtitle }) {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50 dark:bg-gray-950">

            {/* Loader */}
            <div className="relative w-20 h-20 mb-6">

                {/* Outer ring */}
                <div className="absolute inset-0 rounded-full border-4 border-blue-100 dark:border-blue-900"></div>

                {/* Spinning ring */}
                <div className="absolute inset-0 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>

                {/* Center pulse */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-8 h-8 bg-[#D9BB74] rounded-lg animate-pulse"></div>
                </div>
            </div>

            {/* Text */}
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white">
                {title || "Loading..."}
            </h3>

            <p className="text-gray-500 dark:text-gray-400 mt-2">
                {subtitle || "Please wait..."}
            </p>

            {/* bouncing dots */}
            <div className="flex gap-1 mt-4">
                <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce"></span>
                <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce [animation-delay:0.1s]"></span>
                <span className="w-2 h-2 bg-[#D9BB74] rounded-full animate-bounce [animation-delay:0.2s]"></span>
            </div>
        </div>
    );
}